// since we can't strongly type `xliffmerge.json`, `package.json` and `angular.json` we
// have to manually keep in sync those files with this one

export const SupportedLanguages = ['en', 'de', 'fr'] as const;
export type SupportedLanguagesType = (typeof SupportedLanguages)[number];

export const LangToIcon: { [lang in SupportedLanguagesType]: string } = {
  en: 'flag-uk',
  de: 'flag-de',
  fr: 'flag-fr',
};
